var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkill1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7937_6174)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7937_6174",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 90
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 0H0V90H90V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7937_6174)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7937_6174",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 90
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H90V90H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7937_6174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4796 72.4675C49.4796 74.9993 47.4274 77.0516 44.8956 77.0516C42.3638 77.0516 40.3115 74.9993 40.3115 72.4675C40.3115 69.9357 42.3638 67.8835 44.8956 67.8835C47.4274 67.8835 49.4796 69.9357 49.4796 72.4675Z",
    stroke: "#00A0AE",
    strokeWidth: 3.24764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6192 29.2439C65.6192 31.2726 63.9745 32.9173 61.9458 32.9173C59.9171 32.9173 58.2725 31.2726 58.2725 29.2439C58.2725 27.2152 59.9171 25.5706 61.9458 25.5706C63.9745 25.5706 65.6192 27.2152 65.6192 29.2439Z",
    stroke: "#00A0AE",
    strokeWidth: 3.24764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4796 16.584C49.4796 19.1158 47.4274 21.1681 44.8956 21.1681C42.3638 21.1681 40.3115 19.1158 40.3115 16.584C40.3115 14.0522 42.3638 12 44.8956 12C47.4274 12 49.4796 14.0522 49.4796 16.584Z",
    stroke: "#00A0AE",
    strokeWidth: 3.24764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5626 59.5346L59.8064 66.2908M59.8064 59.5346L66.5626 66.2908",
    stroke: "#00A0AE",
    strokeWidth: 3.24764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7562 46.4088L23 53.1649M23 46.4088L29.7562 53.1649",
    stroke: "#00A0AE",
    strokeWidth: 3.24764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5374 61.5365L36.4808 50.8358M37.5983 54.8204L36.4797 50.8353L40.4605 49.7154",
    stroke: "#EEE82C",
    strokeWidth: 3.24764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1834 54.4469L61.7042 39.6856M59.1426 42.9389L61.7042 39.6845L64.9542 42.2461",
    stroke: "#EEE82C",
    strokeWidth: 3.24764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8945 40.4428C31.7608 31.3248 45.6762 31.0723 45.6762 31.0723",
    stroke: "#EEE82C",
    strokeWidth: 3.24764,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.57 5.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6413 28.2537L52.4224 31.3183L49.3577 34.0994",
    stroke: "#EEE82C",
    strokeWidth: 3.24764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7937_6174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill1);
export default __webpack_public_path__ + "static/media/skill1.919fe770555f846760af20c6427a8ae9.svg";
export { ForwardRef as ReactComponent };